// Debug helper for discount issues
// Add ?debug=discounts to any URL to enable debugging

(function() {
  if (window.location.search.includes('debug=discounts')) {
    debugLog('🔍 DISCOUNT DEBUG MODE ENABLED');
    
    // Check cart state
    function debugCart() {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          debugLog('=== CART DEBUG ===');
          debugLog('Discount codes:', cart.discount_codes);
          debugLog('Cart level discounts:', cart.cart_level_discount_applications);
          debugLog('Total price:', cart.total_price);
          debugLog('Original total:', cart.original_total_price);
          debugLog('Items:', cart.items?.length || 0);
          
          if (cart.discount_codes && cart.discount_codes.length > 0) {
            cart.discount_codes.forEach((code, index) => {
              const codeValue = typeof code === 'string' ? code : code.code;
              const applicable = typeof code === 'object' ? code.applicable : 'unknown';
              debugLog(`  Code ${index + 1}: ${codeValue} - Applicable: ${applicable}`);
            });
          }
        });
    }
    
    // Check localStorage
    function debugLocalStorage() {
      debugLog('=== LOCALSTORAGE DEBUG ===');
      const activeDiscount = localStorage.getItem('active_discount');
      debugLog('Active discount:', activeDiscount || 'None');
    }
    
    // Run debug checks
    debugCart();
    debugLocalStorage();
    
    // Re-check every 2 seconds
    setInterval(() => {
      debugCart();
    }, 2000);
    
    // Add global debug function
    window.debugDiscounts = function() {
      debugCart();
      debugLocalStorage();
    };
    
    debugLog('💡 Use window.debugDiscounts() to check cart state anytime');
  }
})();
